module.exports = __webpack_public_path__ + "static/media/report_keynumbers.4e66f15f.svg";